<div class="tab-box">
  <div class="title-ind">
    <h1 class="title-tab">Centros</h1>
    <div class="stackedBarTitle">
      <canvas #stackedCanvasTitleCentro></canvas>
    </div>
  </div>
  <div class="acciones-tabla">
    <app-input-tabla (keyup)="applyFilter($event)"></app-input-tabla>
    <div>
     <!--  <app-nueva-entidad (click)="addCentro()"></app-nueva-entidad> -->
     <button class="boton-descarga" (click)="exportAsExcel()">
      <img class="boton-descarga__icon" src="../../../../../assets/descargar.svg" />
      Descargar
    </button>
    </div>
  </div>
  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
    <!-- <ng-container matColumnDef="id">
      <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
        ID
      </th>

      <td mat-cell *matCellDef="let centro" (click)="openDetails(centro.id)">
        {{ centro?.id }}
      </td>
    </ng-container> -->
    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</th>
      <td mat-cell *matCellDef="let centro" (click)="openDetails(centro.id)">
        {{ centro?.nombre }}
      </td>
    </ng-container>
    <ng-container matColumnDef="nima">
      <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
        NIMA
      </th>
      <td mat-cell *matCellDef="let centro" (click)="openDetails(centro.id)">{{ centro?.nima }}</td>
    </ng-container>
    <ng-container matColumnDef="fechaAlta">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>FECHA DE ALTA</th>
      <td mat-cell *matCellDef="let centro" (click)="openDetails(centro.id)">
        {{ centro?.createdAt | date: 'dd/MM/yyyy' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="contratista.nombreComercial">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>CONTRATISTA</th>
      <td mat-cell *matCellDef="let centro" (click)="openDetails(centro.id)">
        <div *ngIf="centro?.contratista; else elseBlock">
          {{ centro?.contratista?.nombreComercial }}
        </div>
      </td>
      <ng-template #elseBlock>-</ng-template>
    </ng-container>
    <ng-container matColumnDef="indicadores">
      <th mat-header-cell *matHeaderCellDef>INDICADORES</th>
      <td mat-cell *matCellDef="let centro">
        <div class="stackedBar">
          <canvas #stackedCanvasCentro id="{{centro?.id}}"></canvas>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="acciones">
      <th mat-header-cell *matHeaderCellDef>ACCIONES</th>
      <td mat-cell *matCellDef="let centro">
        <!-- <img
          class="tabla-editar"
          src="../../../../../../assets/lapiz.png"
          (click)="updateCentroById(centro.id)"
        /> -->
        <img
          class="tabla-borrar"
          src="../../../../../../assets/trash.png"
          (click)="handleClick(centro.id)"
        />

        <!-- <button (click)="handleDetails(centro.id)">aa</button> -->
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>

    <tr
      mat-row
      *matRowDef="let row; columns: tableColumns"
      style="cursor: pointer;"
    ></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 15, 20]" (click)="getAllCentros()"></mat-paginator>
</div>
